import { DistanceMeasurementComponent } from '@inter-ikea-storageone/range';
import { IvarDistanceMeasurementSystem } from '@inter-ikea-storageone/range-ivar';
import { BehaviorParameters } from 'rangeConfig/@types';

const disableDistanceMeasurements = ({ coreApi }: BehaviorParameters) => {
  coreApi.entities.getByComponent(DistanceMeasurementComponent.id).forEach(entity => {
    const oldComponent = entity.getComponent<DistanceMeasurementComponent>(
      DistanceMeasurementComponent.id
    );
    if (oldComponent) {
      entity.addComponent(
        new DistanceMeasurementComponent(
          oldComponent.directions,
          oldComponent.omitIfRoom,
          oldComponent.measureCloserToWall,
          true
        )
      );
    }

    coreApi.getSystem<IvarDistanceMeasurementSystem>('IvarDistanceMeasurementSystem')?.disable();
  });
};

export default disableDistanceMeasurements;
